<script lang="ts">
  export let tag: string = "span"
  export let onClick: ((event: Event) => void) | undefined = undefined
</script>

<svelte:element
  this={tag}
  on:click={onClick}
  class="screenreader-only"
  {...$$restProps}
>
  <slot />
</svelte:element>

<style>
  .screenreader-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
    opacity: 0;
  }
</style>
